import React, { useEffect, useState, } from 'react';
import { Box,Typography,  } from 
'@mui/material';
import Story from "./story";


function StoryBox(props){



const [isShown,setIsShown]=useState(false)

useEffect(()=>{setIsShown(props.modalHasRun)},[props.modalHasRun])

    return((isShown ? 
    (<Box sx={{border:"solid lightGrey", borderRadius:"5px"}}>
    <Typography varient="h4">
    The Story So Far....
    </Typography>
    <Story melanomaSevenPoint={props.melanomaSevenPoint} idaValues={props.idaValues}/>
    </Box>) : (<></>)))
    

}
export default StoryBox;
